import type {
	SRT_ColumnDef,
	SRT_RowData,
	SRT_StatefulTableOptions,
} from '../../types'

import { SRT_SelectCheckbox } from '../../components/inputs/SRT_SelectCheckbox'
import { defaultDisplayColumnProps } from '../../utils/displayColumn.utils'

export const getSRT_RowSelectColumnDef = <TData extends SRT_RowData>(
	tableOptions: SRT_StatefulTableOptions<TData>
): SRT_ColumnDef<TData> => {
	const { enableMultiRowSelection, enableSelectAll } = tableOptions

	return {
		Cell: ({ row, staticRowIndex, table }) => (
			<SRT_SelectCheckbox
				row={row}
				staticRowIndex={staticRowIndex}
				table={table}
			/>
		),
		Header:
			enableSelectAll && enableMultiRowSelection
				? ({ table }) => <SRT_SelectCheckbox table={table} />
				: '',
		grow: false,
		enableHeaderTooltip: false,
		enableDescriptionTooltip: false,
		...defaultDisplayColumnProps({
			header: 'select',
			id: 'srt-row-select',
			size: enableSelectAll ? 24 : 70,
			tableOptions,
		}),
	}
}
